export class ContextMenuDocument {
  label: string;
  id: number;
  uuid?: string;
  associatedStatements?: number[]
  action?: string;

  constructor(label, id, associatedStatements = [], uuid?: string) {
    this.label = label;
    this.id = id;
    this.associatedStatements = associatedStatements;
    this.uuid = uuid;
  }
}
